import React        from 'react';
import { Collapse } from 'react-bootstrap';
import PropTypes    from 'prop-types'


import Panelized    from 'pu-react/components/Panelized';
import YesPanelized from 'pu-react/components/SectionYesPanelized';

import HasArray       from './HasArray';
import NoPanelized    from './SectionNoPanelized';
import TabRoutScoring from './TabRoutScoring';

function ArrayNeed(props) {
  const {onChangeParameter} = props
  return (
    <div className="array-need">
      <HasArray {...props} />
      <Collapse in={props.parameters.has_array === '1'}>
        <div>
          <div className="array-fields">
            <Panelized {...props} />
            <Collapse in={props.parameters.is_panelized === '1'}>
              <div className="yes-panelized">
                <YesPanelized {...props} />
              </div>
            </Collapse>
            <Collapse in={props.parameters.is_panelized === '0'}>
              <div className="no-panelized">
                <NoPanelized {...props} />
              </div>
            </Collapse>
            <TabRoutScoring {...props} />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

ArrayNeed.propTypes = {
  onChangeParameter: PropTypes.func.isRequired,
  parameters: PropTypes.object.isRequired,
}

export default ArrayNeed;
